<template>
  <div class="mcp-page" :key="lang">

    <div class="section section-main-partner align-items-center mcp-hero">
      <span class="mcp-hero__eyebrow">{{ lang == 'pt' ? 'DESENVOLVEDORES' : 'DEVELOPERS' }}</span>
      <h1 class="mb-3 title">{{ lang == 'pt' ? 'Conector MCP' : 'MCP Connector' }}</h1>
      <p class="mcp-hero__subtitle">{{ subtitle }}</p>
    </div>

    <div class="mcp-container" v-if="show">
      <McpPt :company="company" v-if="lang == 'pt'"></McpPt>
      <McpEn :company="company" v-else></McpEn>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import McpEn from './McpEn'
import McpPt from './McpPt'

export default {
  props: {
    partner_url: {
      type: String,
      default: ''
    },
    window: {
      type: Object,
      default () {
        return { width: 0, height: 0 }
      }
    }
  },
  components: {
    McpEn,
    McpPt
  },
  computed: {
    ...mapState('MainStoreModule', {
      domain: state => state.domain
    }),
    company () {
      return {
        company_name: this.domain.company_name,
        company_fullname: this.domain.company_fullname
      }
    },
    locale () {
      return this.$i18n.locale
    },
    subtitle () {
      return this.lang == 'pt'
        ? 'Conecte o Claude, o ChatGPT ou qualquer cliente de IA compatível com MCP ao seu workspace — e resolva o trabalho a partir de uma conversa.'
        : 'Connect Claude, ChatGPT, or any MCP-compatible AI client to your workspace — and get real work done from a conversation.'
    }
  },
  data () {
    return {
      lang: 'en',
      show: false
    }
  },
  watch: {
    locale (locale) {
      this.lang = locale == 'pt_br' ? 'pt' : locale
    }
  },
  beforeCreate () {
    this.$emit('isPageLoaded', false)
  },
  mounted () {
    this.setUrlData()
    setTimeout(() => {
      this.$emit('isPageLoaded', true)
      this.show = true
    }, 1000)
  },
  methods: {
    ...mapActions('MainStoreModule', [
      'setLocale'
    ]),
    changeLocale (locale) {
      this.$i18n.locale = locale
      this.setLocale(locale)
      this.$moment.locale(locale)
    },
    setUrlData () {
      const params = this.$route.params
      if (Object.keys(params).length && params.lang) {
        this.lang = params.lang
        this.changeLocale(this.lang)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mcp-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 70px 20px 80px;
  background: linear-gradient(135deg, #1c3fc4 0%, #2f5bff 100%) !important;

  &__eyebrow {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: .16em;
    color: rgba(255, 255, 255, .72);
    margin-bottom: 14px;
  }

  h1.title {
    font-size: 52px !important;
    line-height: 1.05 !important;
    font-weight: 700 !important;
    color: #fff;
  }

  &__subtitle {
    max-width: 720px;
    margin: 0 auto;
    font-size: 19px;
    line-height: 1.6;
    color: rgba(255, 255, 255, .9);
  }
}

.mcp-container {
  max-width: 1080px;
  margin: 0 auto;
  padding: 56px 24px 96px;
}

@media only screen and (max-width: 991px) {
  .mcp-hero {
    padding: 48px 20px 56px;
    min-height: auto;

    h1.title {
      font-size: 32px !important;
      width: 100% !important;
      padding: 0 !important;
      margin: 0 0 12px !important;
    }

    &__subtitle {
      font-size: 16px;
    }
  }

  .mcp-container {
    padding: 36px 20px 64px;
  }
}
</style>
